export const QUERY_KEYS = {
  LOGIN_QUERY_KEY: 'user-auth',
  FETCH_APPLICATION_INFO: 'fetch-application-info',
  FETCH_EVALUATION: 'fetch-evaluation',
} as const
